<template>
	<div class="cnt-btn">
		<div v-if="noTitle === false">
			<span v-if="title == null">Imprimir {{ loader }}</span>
			<span v-else>{{ title }}</span>
		</div>
		<div class="input-group">
			<select class="form-control" v-model="impProp">
				<option value="0">Escolher {{ loader }}</option>
				<option
					v-for="(doc, index) in docs_disponiveis"
					:key="index"
					:value="doc.cod"
				>
					{{ doc.titulo }}
				</option>
			</select>
			<span class="input-group-btn">
				<button
					class="btn btn-info"
					@click="download_document"
					:disabled="impProp == 0 && block"
				>
					<i v-if="block" class="fa fa-spin fa-spinner"></i>
					<i v-else class="fa fa-file-text"></i>
				</button>
			</span>
		</div>
	</div>
</template>
<script>
	import { mapState } from 'vuex';
	import WBS from 'js/http';
	import toastr from 'toastr';
	import docTypes from 'js/docsType';

	import jspdf from 'jspdf';

	console.log('printBtn.vue - imported');

	export default {
		name: 'btnGenerateDocuments',
		props: {
			loader: {
				default: null,
				required: true,
			},
			data: {
				default: {},
			},
			title: {
				default: null,
			},
			noTitle: {
				default: false,
			},
		},
		data() {
			return {
				impProp: 0,
				block: false,
				tmp: [],
			};
		},
		computed: {
			...mapState({
				depto: (s) => s.user_data.uid.departamento,
			}),
			docs_disponiveis() {
				return this.tmp.filter((item) => {
					if (this.docs_groups(item.modalidade) == this.loader) {
						if (item.deptos.length == 0) return item;
						if (item.deptos.indexOf(this.depto.cod) != -1)
							return item;
					}
				});
			},
		},
		methods: {
			download_document() {
				if (this.impProp != 0) {
					this.block = true;
					let sData = {
						data: {
							data: this.data,
							tmp: this.tmp.find((e) => e.cod == this.impProp),
						},
						loader: this.loader,
					};
					console.log(sData);
					// const doc = new jspdf()
					// const html = []

					// Object.entries(sData.data.data).forEach((item) => {
					// 	let value = [item[0], ":", item[1]]
					// 	let treated = value.join('')
					// 	html.push(treated)

					// })

					// console.log(html)

					// doc.text(html, 15, 15, {width: 150})
					// doc.save("output.pdf")
					//   console.log(sData)
					WBS.send(
						'protected-custom-replaceDocument',
						sData,
						(resp) => {
							console.log('RESP ', resp);
							console.log('SDATA ', sData);
							this.block = false;
							if (resp.status == 'success') {
								window.open(resp.data);
							} else {
								console.log(resp);
								if (typeof resp == 'string') {
									toastr.error(resp);
								} else {
									if (resp.msgs == undefined) {
										toastr.error('Erro Inesperado');
									} else {
										resp.msgs.forEach((msg) => {
											toastr.error(msg);
										});
									}
								}
							}
						}
					);
				}
			},
			docs_groups(type) {
				let doc = docTypes.find((doc) => doc.id == type);
				return doc !== undefined ? doc.grupo : '';
			},
		},
		mounted() {
			console.log('printBtn mounted');
			WBS.send('protected-read-gridTemplates', (resp) => {
				this.tmp = resp.data;
			});
		},
	};
</script>



// WEBPACK FOOTER //
// src/app-components/printBtn.vue